import {Component, Inject, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModelsService } from '@irb/irb-models/models-new/models.service';
import { AppService } from '@irb/app.service';
import { ReplaySubject } from 'rxjs';


@Component({ standalone: false,
    selector: 'irb-create-new-security-dialog',
    templateUrl: './create-new-security-dialog.component.html',
    styleUrls: ['./create-new-security-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class CreateNewSecurityDialogComponent {

    constructor(public dialogRef: MatDialogRef<any>,
                @Inject(MAT_DIALOG_DATA) public mdd: any
    ) {}

    closeDialog() {
        this.dialogRef.close();
    }

}
